import {
  EMAIL,
  PHONE,
  PHONE_DISPLAY,
  ADDRESS_LINES,
  ADDRESS_SHORT,
  INSTAGRAM_HANDLE,
  INSTAGRAM_URL,
  HOURS,
} from '../constants';

export default function Contact() {
  return (
    <>
      <style>{`
        .ct-hero {
          padding: 120px 0 64px;
          background: var(--charcoal); position: relative; overflow: hidden;
        }
        .ct-hero::before {
          content:''; position:absolute; inset:0;
          background: radial-gradient(circle at 60% 40%, rgba(30,58,95,0.08) 0%, transparent 55%);
        }
        .ct-hero-inner { position: relative; }
        .ct-main { background: var(--sand); padding: 64px 0; }
        .ct-grid {
          display: grid; grid-template-columns: 1fr 1.3fr; gap: 36px;
        }
        .ct-info {
          background: var(--white); border: 1px solid var(--border);
          border-radius: var(--radius); padding: 32px;
        }
        .ct-info-title {
          font-family: var(--font-display); font-size: 22px; font-weight: 600;
          color: var(--charcoal); margin-bottom: 24px;
        }
        .ct-item { display: flex; gap: 12px; align-items: flex-start; margin-bottom: 20px; }
        .ct-item-icon {
          width: 36px; height: 36px; border-radius: 8px;
          background: var(--terra-pale); border: 1px solid rgba(30,58,95,0.15);
          display: flex; align-items: center; justify-content: center;
          font-size: 15px; flex-shrink: 0;
        }
        .ct-item-lbl {
          font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase;
          color: var(--terra); display: block; margin-bottom: 3px;
        }
        .ct-item-val { font-size: 13.5px; color: var(--text-mid); line-height: 1.5; }
        .ct-div { border: none; border-top: 1px solid var(--border); margin: 20px 0; }
        .hours-row { display: flex; justify-content: space-between; margin-bottom: 8px; }
        .hr-day { font-size: 12.5px; color: var(--text-muted); }
        .hr-time { font-size: 12.5px; color: var(--text-mid); font-weight: 500; }
        .map-box {
          margin-top: 20px; background: var(--sand-mid); border: 1px solid var(--border);
          border-radius: var(--radius-sm); height: 160px;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          gap: 6px;
        }
        .map-box-lbl { font-size: 12px; color: var(--text-muted); }

        .ct-form {
          background: var(--white); border: 1px solid var(--border);
          border-radius: var(--radius); padding: 32px;
        }
        .ct-form-title {
          font-family: var(--font-display); font-size: 22px; font-weight: 600;
          color: var(--charcoal); margin-bottom: 6px;
        }
        .ct-form-sub { font-size: 13.5px; color: var(--text-muted); margin-bottom: 24px; }
        .f-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 14px; }
        .f-group { margin-bottom: 14px; }
        .f-label {
          font-size: 12px; font-weight: 500; color: var(--text-mid);
          margin-bottom: 6px; display: block; letter-spacing: 0.04em;
        }
        .f-input, .f-select, .f-textarea {
          width: 100%; padding: 10px 13px; border-radius: var(--radius-sm);
          border: 1px solid var(--border); background: var(--sand);
          font-size: 14px; font-family: var(--font-body); color: var(--charcoal);
          outline: none; transition: border-color 0.2s;
        }
        .f-input:focus, .f-select:focus, .f-textarea:focus {
          border-color: var(--terra); background: var(--white);
        }
        .f-textarea { resize: vertical; min-height: 90px; }
        .f-submit {
          width: 100%; padding: 13px; border-radius: var(--radius-sm);
          background: var(--terra); color: white;
          font-size: 15px; font-weight: 600; font-family: var(--font-body);
          border: none; cursor: pointer; transition: all 0.2s;
        }
        .f-submit:hover { background: var(--terra-dark); transform: translateY(-1px); }
        .f-note { font-size: 11.5px; color: var(--text-muted); text-align: center; margin-top: 10px; }

        @media (max-width: 900px) {
          .ct-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 540px) {
          .f-row { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="ct-hero">
        <div className="container ct-hero-inner">
          <span className="eyebrow" style={{color:'var(--accent)'}}>Contact Us</span>
          <h1 style={{fontFamily:'var(--font-display)',fontSize:'clamp(34px,5vw,54px)',fontWeight:600,color:'white',lineHeight:1.1,letterSpacing:'-0.01em',marginBottom:14,maxWidth:500}}>
            We would love to<br /><em style={{fontStyle:'italic',color:'var(--accent)'}}>hear from you.</em>
          </h1>
          <p style={{fontSize:15,color:'rgba(255,255,255,0.5)',maxWidth:440,lineHeight:1.75}}>
            Book an appointment, enquire about practitioner rooms, or just say hello.
          </p>
        </div>
      </div>

      <div className="ct-main">
        <div className="container">
          <div className="ct-grid">
            <div className="ct-info">
              <div className="ct-info-title">Get in touch</div>

              <div className="ct-item">
                <div className="ct-item-icon">📍</div>
                <div>
                  <span className="ct-item-lbl">Address</span>
                  <span className="ct-item-val">
                    {ADDRESS_LINES.map((line, i) => (
                      <span key={i}>{line}{i < ADDRESS_LINES.length - 1 && <br />}</span>
                    ))}
                  </span>
                </div>
              </div>

              <div className="ct-item">
                <div className="ct-item-icon">📞</div>
                <div>
                  <span className="ct-item-lbl">Phone</span>
                  <a className="ct-item-val" href={`tel:${PHONE}`} style={{textDecoration:'none'}}>{PHONE_DISPLAY}</a>
                </div>
              </div>

              <div className="ct-item">
                <div className="ct-item-icon">✉️</div>
                <div>
                  <span className="ct-item-lbl">Email</span>
                  <a className="ct-item-val" href={`mailto:${EMAIL}`} style={{textDecoration:'none'}}>{EMAIL}</a>
                </div>
              </div>

              <div className="ct-item">
                <div className="ct-item-icon">📱</div>
                <div>
                  <span className="ct-item-lbl">Instagram</span>
                  <a className="ct-item-val" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" style={{textDecoration:'none'}}>{INSTAGRAM_HANDLE}</a>
                </div>
              </div>

              <hr className="ct-div" />
              <div style={{fontSize:10,letterSpacing:'0.12em',textTransform:'uppercase',color:'var(--terra)',marginBottom:12}}>Operating Hours</div>
              {HOURS.map(([d,t]) => (
                <div key={d} className="hours-row">
                  <span className="hr-day">{d}</span>
                  <span className="hr-time">{t}</span>
                </div>
              ))}

              <div className="map-box">
                <span style={{fontSize:28}}>📍</span>
                <span className="map-box-lbl">{ADDRESS_SHORT}</span>
                <span style={{fontSize:11,color:'var(--sand-deep)'}}>Add Google Maps embed here</span>
              </div>
            </div>

            <div className="ct-form">
              <div className="ct-form-title">Book an Appointment</div>
              <p className="ct-form-sub">Fill in your details and we will get back to you shortly.</p>

              <div className="f-row">
                <div>
                  <label className="f-label">First Name</label>
                  <input className="f-input" type="text" placeholder="Ravi" />
                </div>
                <div>
                  <label className="f-label">Last Name</label>
                  <input className="f-input" type="text" placeholder="Kumar" />
                </div>
              </div>
              <div className="f-group">
                <label className="f-label">Phone Number</label>
                <input className="f-input" type="tel" placeholder="+91 9XXXXXXXXX" />
              </div>
              <div className="f-group">
                <label className="f-label">Email Address</label>
                <input className="f-input" type="email" placeholder="you@example.com" />
              </div>
              <div className="f-group">
                <label className="f-label">I am a</label>
                <select className="f-select">
                  <option value="">Select...</option>
                  <option>Practitioner — looking to join</option>
                  <option>Patient — looking to book appointment</option>
                  <option>Other enquiry</option>
                </select>
              </div>
              <div className="f-group">
                <label className="f-label">Specialty / Department (if applicable)</label>
                <select className="f-select">
                  <option value="">Select a specialty</option>
                  <option>General Medicine</option>
                  <option>Cardiology</option>
                  <option>Dental Care</option>
                  <option>Dermatology</option>
                  <option>Gynecology</option>
                  <option>Orthopedics</option>
                  <option>Pediatrics</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="f-group">
                <label className="f-label">Message (optional)</label>
                <textarea className="f-textarea" placeholder="Any specific questions or requirements..." />
              </div>
              <button className="f-submit">Submit Enquiry →</button>
              <p className="f-note">We will get back to you within 24 hours.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
